
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { ContactFormStoreReducer } from './reducer';
import { ContactFormStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, ContactFormStoreReducer),
		EffectsModule.forFeature([ContactFormStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ContactFormStoreModule { }
